import { useCallback } from "react";
import { Flex } from "@radix-ui/themes";
import { SelectOption } from "@/components/shared/select/Select";
import { TagList } from "./TagList";
import { AddTagButton } from "./AddTagButton";

interface TagPickerProps {
  options: SelectOption[];
  value?: string[];
  loading?: boolean;
  classes?: {
    list?: string;
    addButton?: string;
  };
  onChange: (value: string[]) => void;
}

export function TagPicker({
  options,
  value,
  loading,
  classes = {},
  onChange,
}: TagPickerProps) {
  const handleAdd = useCallback(
    (option: SelectOption) => {
      onChange([...(value ?? []), option.value]);
    },
    [value, onChange]
  );

  const handleRemove = useCallback(
    (optionToRemove: string) => {
      if (value == null) {
        return;
      }

      onChange(value.filter((v) => v !== optionToRemove));
    },
    [value, onChange]
  );

  return (
    <Flex gap="2" wrap="wrap">
      <TagList
        options={options}
        value={value}
        loading={loading}
        className={classes.list}
        onRemove={handleRemove}
      />

      <AddTagButton
        options={options}
        value={value}
        loading={loading}
        className={classes.addButton}
        onAdd={handleAdd}
      />
    </Flex>
  );
}
